module.exports = __webpack_public_path__ + "static/media/manual_close.7f9d4d1d.png";